module.exports = __webpack_public_path__ + "static/media/profil.5c0dd441.png";